var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/analytics/common/src/analytics/helper.ts
import { win } from "@gs-ux-uitoolkit-common/shared";
function getAppTitle() {
  return document.title;
}
function getAppName() {
  var _a;
  return (_a = document.querySelector(".app-header .app-name h1")) == null ? void 0 : _a.innerHTML.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
}
function isAlias(host) {
  const nonAliasPatterns = [
    /.*\.desktop\.services\.gs\.com/,
    /nds[0-9a-z]+\.firmwide\.corp\.gs\.com/,
    /localhost(\.gs\.com)?/,
    /.+\.dc\.gs\.com/
  ];
  return !nonAliasPatterns.reduce((total, cur) => total || cur.test(host), null);
}
function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) {
      return "";
    }
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}
function getOsName() {
  if (hasNameInUserAgent("windows"))
    return "windows";
  if (hasNameInUserAgent("mac"))
    return "mac";
  if (hasNameInUserAgent("android"))
    return "android";
  if (hasNameInUserAgent("iphone") || hasNameInUserAgent("ipad"))
    return "ios";
  return "other";
}
function getIsTouchDevice() {
  return "ontouchstart" in win || win.DocumentTouch && document instanceof win.DocumentTouch || navigator.maxTouchPoints > 0 || win.navigator.maxTouchPoints > 0;
}
function getVersionNumberParts(version) {
  const match = version.match(/(\d+)\.(\d+)\.(\d+)/);
  return {
    major: match && Number(match[1]) || 0,
    minor: match && Number(match[2]) || 0,
    patch: match && Number(match[3]) || 0
  };
}
function getBrowserName() {
  const { userAgent } = win.navigator;
  const userAgentString = userAgent.toLowerCase();
  let browserName = "other";
  if (userAgentString.includes("firefox")) {
    browserName = "firefox";
  } else if (userAgentString.includes("edg/") || userAgentString.includes("edge")) {
    browserName = "edge";
  } else if (userAgentString.includes("chrome")) {
    browserName = "chrome";
  } else if (userAgentString.includes("safari")) {
    browserName = "safari";
  } else if (userAgentString.includes("trident")) {
    browserName = "ie";
  }
  return browserName;
}
function hasNameInUserAgent(name) {
  const userAgentString = win.navigator.userAgent.toLowerCase();
  return userAgentString.includes(name.toLowerCase());
}
function isMobile() {
  var _a;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    ((_a = win.navigator) == null ? void 0 : _a.userAgent) || ""
  );
}

// components/analytics/common/src/index.ts
import { log } from "gs-uitk-analytics-common";

// components/analytics/common/src/analytics/component-analytics.ts
import { win as win3, trackComponentVersion } from "@gs-ux-uitoolkit-common/shared";

// components/analytics/common/src/analytics/toolkit-analytics.ts
import { win as win2 } from "@gs-ux-uitoolkit-common/shared";

// components/analytics/common/src/analytics/analytics.ts
import { AbstractAnalytics } from "gs-uitk-analytics-common";
var Analytics = class extends AbstractAnalytics {
  /**
   * Posts the data as a JSON string to the configured endpoint. Does not wait
   * for a return or perform a callback. If this call fails the error will not leak to the window.
   * @param {Object} data The data to be posted to the endpoint
   */
  post(data) {
    return new Promise((resolve, reject) => {
      const xmlhttp = new XMLHttpRequest();
      xmlhttp.open("POST", this.config.url);
      xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xmlhttp.withCredentials = !!this.config.credentials;
      xmlhttp.onreadystatechange = () => {
        if (xmlhttp.readyState === 4) {
          if (xmlhttp.status >= 200 && xmlhttp.status <= 299) {
            resolve();
          } else {
            reject();
          }
        }
      };
      xmlhttp.send(JSON.stringify(data));
    });
  }
  getClientConfig() {
    return {
      os: {
        name: getOsName()
      },
      browser: {
        userAgent: navigator.userAgent,
        name: getBrowserName(),
        isMobile: isMobile(),
        isTouchDevice: getIsTouchDevice()
      },
      screen: {
        height: window.screen.height,
        width: window.screen.width,
        viewportWidth: window.innerWidth || 0,
        viewportHeight: window.innerHeight || 0
      }
    };
  }
};

// components/analytics/common/src/analytics/toolkit-analytics-config.ts
import { isBrowser } from "@gs-ux-uitoolkit-common/shared";
var qaUrl = "https://gs-analytics-qa.url.gs.com:8443/appevent/bulk";
var batch = isBrowser;
var toolkitProdAnalyticsConfig = {
  url: "https://gs-analytics.url.gs.com:8443/appevent/bulk",
  token: "98311094-bcd0-41ab-8346-2d9cc6b715c4",
  batch,
  errorTolerance: 10,
  batchSyncInterval: 10 * 1e3,
  maxBatchItems: 50,
  deploymentId: "148898",
  deduplicate: true,
  credentials: false,
  appId: "27399"
};
var toolkitQaAnalyticsConfig = {
  url: qaUrl,
  token: "94ad9122-e982-4a68-a94e-98b69f981419",
  batch,
  errorTolerance: 10,
  batchSyncInterval: 10 * 1e3,
  maxBatchItems: 50,
  deploymentId: "148907",
  deduplicate: true,
  credentials: false,
  appId: "27399"
};

// components/analytics/common/src/analytics/toolkit-analytics.ts
var ToolkitAnalytics = class {
  constructor() {
    this.analytics = void 0;
    this.trackQueue = [];
    this.isRunning = true;
    if (win2 && win2.document) {
      switch (document.readyState) {
        case "loading":
          document.addEventListener("DOMContentLoaded", () => this.initialize());
          break;
        case "interactive":
        case "complete":
          this.initialize();
          break;
      }
    }
  }
  destroy() {
    if (this.analytics) {
      this.analytics.stop();
      this.analytics = void 0;
    }
    this.trackQueue = [];
  }
  initialize() {
    const isQa = win2 && win2.UITOOLKIT_ANALYTICS_LOG_TO_QA;
    const isDisabled = win2 && win2.GS_UX_UITOOLKIT_DISABLE_COMPONENT_ANALYTICS;
    this.analytics = new Analytics(
      isQa ? toolkitQaAnalyticsConfig : toolkitProdAnalyticsConfig
    );
    if (!isDisabled && this.isRunning) {
      this.analytics.start();
    } else {
      this.analytics.stop();
    }
    this.trackQueue.forEach((item) => this.track(item));
    this.trackQueue = [];
  }
  stop() {
    if (this.analytics) {
      this.analytics.stop();
    } else {
      this.isRunning = false;
    }
  }
  start() {
    if (this.analytics) {
      this.analytics.start();
    } else {
      this.isRunning = true;
    }
  }
  track(options) {
    const hostApplication = {
      title: getAppTitle() || "",
      host: location.host,
      port: location.port,
      hostname: location.hostname
    };
    const analyticsProperties = __spreadProps(__spreadValues({}, options.properties), {
      count: 1,
      payloadModelVersion: "v2",
      app: hostApplication
    });
    const trackDetails = {
      eventName: options.eventName,
      properties: analyticsProperties,
      customApplicationProperties: options.applicationDetails
    };
    if (this.analytics && this.canTrack()) {
      this.analytics.track(trackDetails);
    } else {
      this.trackQueue.push(trackDetails);
    }
  }
  canTrack() {
    return !this.isDisabled() && (!this.isLocalhost() || this.isQa());
  }
  isQa() {
    return win2 && win2.UITOOLKIT_ANALYTICS_LOG_TO_QA;
  }
  isDisabled() {
    return win2 && win2.GS_UX_UITOOLKIT_DISABLE_COMPONENT_ANALYTICS;
  }
  isLocalhost() {
    var _a, _b;
    return (_b = (_a = win2) == null ? void 0 : _a.location) == null ? void 0 : _b.host.includes("localhost");
  }
};
var toolkitAnalytics = new ToolkitAnalytics();

// components/analytics/common/src/analytics/component-analytics.ts
var toolkitAnalyticsName = "UI Toolkit";
var ComponentAnalytics = class {
  constructor(componentAnalyticsArgs) {
    this.packageName = componentAnalyticsArgs.packageName;
    this.version = componentAnalyticsArgs.version;
    this.framework = this.getComponentFramework(componentAnalyticsArgs.packageName);
    this.componentName = this.getComponentName(componentAnalyticsArgs.packageName);
    this.validateSameComponentVersion();
  }
  // check to see if all components are using the same version number
  validateSameComponentVersion() {
    trackComponentVersion(this.packageName, this.version);
  }
  /**
   * track component package loaded/used
   */
  trackPackageLoad() {
    if (win3) {
      this.track({
        eventName: "Load"
      });
    }
  }
  /**
   * tracks Component render
   */
  trackRender(trackingArgs) {
    this.track({
      eventName: "Rendered",
      properties: trackingArgs.features,
      featureName: trackingArgs.componentName,
      officialComponentName: trackingArgs.officialComponentName
    });
  }
  /**
   * tracking function to tracking an event
   * Example:
   * this.track({
   *      eventName: 'Rendered',
   *      features: {isDra:true},
   *     featureName: 'DataGrid',
   *   });
   */
  track(trackingArgs) {
    const versionParts = getVersionNumberParts(this.version || "");
    const componentProperty = {
      name: trackingArgs.featureName || this.componentName,
      framework: this.framework,
      officialComponentName: trackingArgs.officialComponentName || "other",
      packageName: this.packageName,
      version: {
        full: this.version,
        major: String(versionParts.major),
        minor: String(versionParts.minor),
        patch: String(versionParts.patch)
      },
      config: __spreadValues({}, trackingArgs.properties)
    };
    toolkitAnalytics.track({
      eventName: trackingArgs.eventName,
      properties: {
        component: componentProperty
      },
      applicationDetails: this.getApplicationTrackingDetails()
    });
  }
  getComponentName(packageName) {
    return packageName.substring(packageName.lastIndexOf("/") + 1, packageName.length);
  }
  getComponentFramework(packageName) {
    const parts = packageName.split("@gs-ux-uitoolkit-");
    if (parts[1]) {
      return parts[1].split("/")[0];
    }
    return "unknown";
  }
  getApplicationTrackingDetails() {
    return {
      version: this.version,
      component: this.packageName,
      platform: this.framework,
      name: toolkitAnalyticsName
    };
  }
};

// components/analytics/common/src/index.ts
var AnalyticsHelper = { getAppTitle, getAppName, isAlias, camelize, log };
export {
  Analytics,
  AnalyticsHelper,
  ComponentAnalytics,
  ToolkitAnalytics,
  toolkitAnalytics,
  toolkitAnalyticsName
};
//# sourceMappingURL=index.mjs.map
